"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cookieCategoryListToMap = void 0;
const isBrowserStorageInfoCategory_1 = require("./isBrowserStorageInfoCategory");
const cookieCategoryListToMap = (cookieCategoryList) => {
    const categoryMappings = {};
    (cookieCategoryList || []).forEach(cookie => {
        const { name, category } = cookie || {};
        if (!cookie || !name || !(0, isBrowserStorageInfoCategory_1.isBrowserStorageInfoCategory)(category)) {
            return;
        }
        categoryMappings[name] = category;
    });
    return categoryMappings;
};
exports.cookieCategoryListToMap = cookieCategoryListToMap;
//# sourceMappingURL=cookieCategoryListToMap.js.map